import React from 'react';
import "./Header.css"

const Header = () => {
  return (
    <header className="masthead" id="page-top">
      <div className="container d-flex h-100 align-items-center">
        <div className="mx-auto text-center">
          <h1 className="text-white">Vanessa Ferreira</h1>
          <p className="text-white-50">Frontend Developer</p>
        </div>
      </div>
    </header>
  );
};

export default Header;

//change the font, font size, give it some nice effects...shadows etc